module.exports = __webpack_public_path__ + "img/clock.18f743eb.svg";